"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCriteriaNameKey = void 0;
var SearchCriteriaNameKey;
(function (SearchCriteriaNameKey) {
    SearchCriteriaNameKey["categories"] = "cc";
    SearchCriteriaNameKey["cities"] = "wp";
    SearchCriteriaNameKey["contractTypes"] = "tc";
    SearchCriteriaNameKey["countries"] = "ct";
    SearchCriteriaNameKey["employerID"] = "eid";
    SearchCriteriaNameKey["employers"] = "en";
    SearchCriteriaNameKey["excludedWorkPlaces"] = "ewp";
    SearchCriteriaNameKey["isAboutProject"] = "ap";
    SearchCriteriaNameKey["isAgencyOnly"] = "ao";
    SearchCriteriaNameKey["isJobicon"] = "jobicon";
    SearchCriteriaNameKey["isOneClickApply"] = "oca";
    SearchCriteriaNameKey["isOptionalCV"] = "ocv";
    SearchCriteriaNameKey["isRemoteRecruitment"] = "rr";
    SearchCriteriaNameKey["isRemoteWork"] = "rw";
    SearchCriteriaNameKey["isSuperOffer"] = "so";
    SearchCriteriaNameKey["isUkrainianFriendly"] = "ua";
    SearchCriteriaNameKey["isWholePoland"] = "iwhpl";
    SearchCriteriaNameKey["itSpecializations"] = "its";
    SearchCriteriaNameKey["itTechnologiesHighlighted"] = "itth";
    SearchCriteriaNameKey["jobOfferID"] = "joid";
    SearchCriteriaNameKey["jobTitles"] = "kw";
    SearchCriteriaNameKey["keyword"] = "kw";
    SearchCriteriaNameKey["pageNumber"] = "pn";
    SearchCriteriaNameKey["partitionID"] = "oid";
    SearchCriteriaNameKey["period"] = "p";
    SearchCriteriaNameKey["popular"] = "popular";
    SearchCriteriaNameKey["positionLevels"] = "et";
    SearchCriteriaNameKey["productBranches"] = "pb";
    SearchCriteriaNameKey["radius"] = "rd";
    SearchCriteriaNameKey["regions"] = "r";
    SearchCriteriaNameKey["rowsOnPage"] = "rop";
    SearchCriteriaNameKey["salary"] = "sal";
    SearchCriteriaNameKey["salaryMax"] = "salMax";
    SearchCriteriaNameKey["salaryMin"] = "salMin";
    SearchCriteriaNameKey["salaryRate"] = "salRate";
    SearchCriteriaNameKey["salaryBonus"] = "salb";
    SearchCriteriaNameKey["skills"] = "kw";
    SearchCriteriaNameKey["sortColumn"] = "sc";
    SearchCriteriaNameKey["withoutPolishLanguage"] = "wpl";
    SearchCriteriaNameKey["withCompanyCar"] = "ccar";
    SearchCriteriaNameKey["workModes"] = "wm";
    SearchCriteriaNameKey["requiredLanguages"] = "rl";
    SearchCriteriaNameKey["workplace"] = "wp";
    SearchCriteriaNameKey["workSchedules"] = "ws";
    SearchCriteriaNameKey["withSalary"] = "hs";
})(SearchCriteriaNameKey || (exports.SearchCriteriaNameKey = SearchCriteriaNameKey = {}));
